"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.right = exports.left = exports.Either = void 0;
var web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "Either", { enumerable: true, get: function () { return web_ui_framework_1.Either; } });
Object.defineProperty(exports, "left", { enumerable: true, get: function () { return web_ui_framework_1.left; } });
Object.defineProperty(exports, "right", { enumerable: true, get: function () { return web_ui_framework_1.right; } });
//# sourceMappingURL=index.js.map